<template>
  <div>
    <Label :htmlFor="id" medium>パスワード</Label>
    <PasswordInput :id="id" v-model="inputPassword" width="312"> </PasswordInput>
  </div>
</template>

<script>
import PasswordInput from '@/components/_atoms/inputs/PasswordInput.vue';
import Label from '@/components/_atoms/labels/Label.vue';

export default {
  name: 'LabelPasswordInput',
  components: {
    PasswordInput,
    Label
  },
  model: { prop: 'passwordText', event: 'password' },
  props: {
    id: { type: String, required: false },
    passwordText: { type: String, default: '' }
  },
  computed: {
    inputPassword: {
      get() {
        return this.passwordText;
      },
      set(val) {
        this.$emit('password', val);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_molecules/LabelPasswordInput.vue